import { useEffect } from 'react';
import { useOutletContext } from 'react-router';

type PageIdSetter = (pageId: string) => void;

export default function usePageId(pageId: string) {
	const setPageId = useOutletContext<PageIdSetter>();

	useEffect(() => {
		if (setPageId) {
			setPageId(pageId);
		}
	}, [setPageId, pageId]);
}
